import { ExerciseByIdInterface, ExerciseDispatchTypes, ExerciseListInterface, ExerciseTypes } from './types';

interface DefaultExerciseState {
	loading: boolean;
	exercises?: ExerciseListInterface;
	exercise?: ExerciseByIdInterface;
	error: any | undefined;
}

const defaultState: DefaultExerciseState = {
    loading: false,
    error: ''
};

const exerciseReducer = (state: DefaultExerciseState = defaultState, action: ExerciseDispatchTypes) => {
	switch (action.type) {
		case ExerciseTypes.LOAD_ALL_EXERCISE:
			return { ...state, loading: false, exercises: action.payload , exercise: undefined,error:undefined};
		case ExerciseTypes.LOAD_EXERCISE_FAIL:
			return { ...state, loading: false, error: action?.payload?.errors , exercise: undefined };
		case ExerciseTypes.LOAD_EXERCISE_BY_ID:
			return { ...state,loading:false,exercise:action.payload,error:undefined}
		default:
			return state;
	}
};

export default exerciseReducer;
